/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactSelect, { Option } from 'react-select'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { capitalize } from 'plugin-codaf-risk-ext-bowtie/utils'

import { EntityEditorModal, SwitchButton } from '../../../../../generic'
import { getBarrier, IBarriersListFilters, listBarriers, listBarrierTypes } from '../../../../../services'
import { IReduxActions, IReduxReducers } from '../../../../../store'
import { IBowtie, IBarrier, IBarrierType, ISelectOptionType } from '../../../../../types'
import { Barrier_Editor_URL } from '../../../../../utils/constants'
import { IConsequenceEditor, IThreatEditor } from '../../BowtieEditor'
import {
    BarrierInfoContainer,
    InfoBarrierFlex,
    StyledCustomTooltip,
    Title,
    Container,
    DisableableIcon,
    FormField
} from './styles'

type IProps = {
    data: IBowtie
    handleClose: () => void
    handleChange: (barrier?: IBarrier, mandatoryThreat?: boolean, isTopEventMandatory?: boolean) => void
    handleDeleteClick: () => void
    item: IBarrier
    isThreatConsequenceMandatory: boolean
    isTopEventMandatory: boolean
    setItem: (i: IBarrier) => void
    isOpen: boolean
    borderColor: string
    title: string
    type: IType
    escId?: string
    updateBarriers?: (updatedBarrier: IBarrier) => void
}

type IType = 'threat' | 'consequence'

export const BarrierAssignModal: React.FC<IProps> = props => {
    const {
        data,
        handleClose,
        item,
        setItem,
        isOpen,
        isThreatConsequenceMandatory,
        isTopEventMandatory,
        handleChange,
        borderColor,
        title,
        type,
        escId,
        handleDeleteClick,
        updateBarriers
    } = props

    const [refreshBarriers, setRefreshBarriers] = useState<boolean>(false)
    const [barrierTypes, setBarrierTypes] = useState<IBarrierType[]>([])
    const [barriers, setBarriers] = useState<IBarrier[]>([])
    const [selectedBarrierType, setSelectedBarrierType] = useState<ISelectOptionType>()
    const [selectedBarrier, setSelectedBarrier] = useState<IBarrier>()
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const fatherId = escId
        ? escId
              .split('|')
              .shift()
              .replace('thr-', '')
              .replace('cnq-', '')
        : //   .replace(/\D/g, '')
          undefined

    const index =
        type === 'threat'
            ? data?.topEvent?.threats?.findIndex((t: IThreatEditor) => {
                  if (fatherId?.startsWith('u')) {
                      return t.uid === fatherId
                  } else {
                      return t.id === Number(fatherId)
                  }
              })
            : data?.topEvent?.consequences?.findIndex((c: IConsequenceEditor) => {
                  if (fatherId?.startsWith('u')) {
                      return c.uid === fatherId
                  } else {
                      return c.id === Number(fatherId)
                  }
              })

    const threatText = i18n(
        `Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs. \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite`
    )
    const consequenceText = i18n(
        `Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite`
    )

    const dispatch = useDispatch()
    const { consequencesExpandedBarriers, threatsExpandedBarriers } = useSelector(
        (state: IReduxReducers) => state.bowtieExpandedBarriers
    )

    const handleSelectNewInfo = async (barrierId: number): Promise<void> => {
        if (escId) {
            const expandedBarriers = type === 'threat' ? threatsExpandedBarriers : consequencesExpandedBarriers
            const newExpandedBarriers = expandedBarriers.filter(el => !el.barrierId.startsWith(escId))

            dispatch<IReduxActions['bowtieExpandedBarriers']>({
                type: type === 'threat' ? 'SET_THREAT_EXPANDED_BARRIERS' : 'SET_CONSEQUENCE_EXPANDED_BARRIERS',
                payload: { newExpandedBarriers }
            })
        }

        const newItem = await getBarrier(barrierId)
        setItem(newItem)
        setSelectedBarrier(newItem)
        handleChange(newItem, isThreatConsequenceMandatory, isTopEventMandatory)
    }

    const handleDelete = (): void => {
        const expandedBarriers = type === 'threat' ? threatsExpandedBarriers : consequencesExpandedBarriers

        if (type === 'threat') {
            const newBarriers = data.topEvent.threats[index].barriers?.filter(old => old !== item)
            data.topEvent.threats[index].barriers = newBarriers
        }

        if (type === 'consequence') {
            const newBarriers = data.topEvent.consequences[index].barriers?.filter(old => old !== item)
            data.topEvent.consequences[index].barriers = newBarriers
        }

        dispatch<IReduxActions['bowtieExpandedBarriers']>({
            type: type === 'threat' ? 'SET_THREAT_EXPANDED_BARRIERS' : 'SET_CONSEQUENCE_EXPANDED_BARRIERS',
            payload: {
                newExpandedBarriers: expandedBarriers.filter(el => !el.barrierId.startsWith(escId))
            }
        })
        handleDeleteClick()
    }

    const goToEditBarrier = (barrier: IBarrier): void => {
        window.open(`${Barrier_Editor_URL(barrier.id)}`)
    }

    useEffect(() => {
        const handleOpen = async (): Promise<void> => {
            const barrierTypesFetch = await listBarrierTypes()

            const barrierListParams: IBarriersListFilters = {
                filterBy: data.asset.id
            }
            const barriersFetch = await listBarriers(barrierListParams)
            setBarrierTypes(barrierTypesFetch.data)

            if (data.methodType === 'SEMI_QUALITATIVE') {
                setBarriers(barriersFetch.data.filter(barriers => barriers.method.method === 'QUALITATIVE'))
            } else {
                setBarriers(barriersFetch.data)
            }

            if (item && item.barrierType) {
                setSelectedBarrier(item)
                setSelectedBarrierType({
                    label: item.barrierType?.name,
                    value: item.barrierType?.id
                })
            } else {
                setSelectedBarrierType(undefined)
                setSelectedBarrier(undefined)
            }
        }

        if (isOpen) {
            handleOpen()
        }
    }, [isOpen, item]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleBarrierTypeChange = (object: ISelectOptionType): void => {
        setSelectedBarrierType(object)
        setSelectedBarrier(undefined)
    }

    async function handleBarrierListRefresh() {
        const barrierTypesFetch = await listBarrierTypes()
        setBarrierTypes(barrierTypesFetch.data)
        if (selectedBarrierType !== null) {
            const newSelectedBarrierType = barrierTypesFetch.data.find(el => el.id === selectedBarrierType.value)
            // setSelectedBarrierType({ label: newSelectedBarrierType.name, value: newSelectedBarrierType.id })
        }
    }

    async function handleRecursiveUpdate(id: number) {
        try {
            setRefreshBarriers(true)
            const barrierListParams: IBarriersListFilters = {
                filterBy: data.asset.id
            }
            handleBarrierListRefresh()
            const barriersFetch = await listBarriers(barrierListParams)
            setBarriers(barriersFetch.data)
            if (selectedBarrier) {
                const newSelectedBarrier = barriersFetch.data.find(el => el.id === selectedBarrier.id)
                setSelectedBarrier(newSelectedBarrier)
            }
            const barrier = await getBarrier(id)
            updateBarriers(barrier)
            if (type === 'threat') {
                const idx = data.topEvent.threats[index - 1]?.barriers.findIndex(brr => brr.id === barrier.id)
                setSelectedBarrier(data.topEvent.threats[index - 1]?.barriers[idx])
                setItem(data.topEvent.threats[index - 1]?.barriers[idx])
            } else {
                const idx = data.topEvent.consequences[index - 1]?.barriers.findIndex(brr => brr.id === barrier.id)
                setSelectedBarrier(data.topEvent.consequences[index - 1]?.barriers[idx])
                setItem(data.topEvent.consequences[index - 1]?.barriers[idx])
            }
        } catch (err) {
            console.log(err)
        } finally {
            setRefreshBarriers(false)
        }
    }

    return (
        <EntityEditorModal
            handleClose={() => {
                if (item.name !== '') {
                    setSelectedBarrier(null)
                } else {
                    handleDelete()
                }
                handleClose()
            }}
            isOpen={isOpen}
            borderColor={borderColor}
            headerTitle={i18n(title)}
            headerSubtitle={item?.id ? '#' + item.id : ''}
        >
            <FormField>
                <Label required className="control-label">
                    {i18n('Barrier Category')}
                </Label>
                {bowtieAdmin ? (
                    <ReactSelect
                        options={barrierTypes.map(bt => ({ value: bt.id, label: bt.name }))}
                        searchable={true}
                        clearable={true}
                        onChange={handleBarrierTypeChange}
                        id="bowtieEditor-barrierAssignModal-field-barrierType"
                        value={selectedBarrierType}
                    />
                ) : (
                    <ReactSelect
                        options={barrierTypes.map(bt => ({ value: bt.id, label: bt.name }))}
                        searchable={true}
                        clearable={true}
                        disabled
                        id="bowtieEditor-barrierAssignModal-field-barrierType"
                        value={selectedBarrierType}
                    />
                )}
            </FormField>
            <FormField>
                <Container>
                    <Label required className="control-label" styles={{ width: '90%' }}>
                        {i18n('Barrier')}
                    </Label>
                    {bowtieAdmin && (
                        <DisableableIcon
                            className={`fas fa-sync-alt ${refreshBarriers && 'fa-spin'}`}
                            disabled={refreshBarriers}
                            onClick={() => {
                                !refreshBarriers && handleRecursiveUpdate(selectedBarrier?.id)
                            }}
                        />
                    )}
                </Container>
                {bowtieAdmin ? (
                    <ReactSelect
                        disabled={!selectedBarrierType || refreshBarriers}
                        options={barriers
                            .filter(bar => selectedBarrierType?.value === bar.barrierType?.id)
                            .filter(bar =>
                                type === 'threat'
                                    ? data?.topEvent?.threats[index]?.barriers.every(b => b.id !== bar.id)
                                    : data?.topEvent?.consequences[index]?.barriers.every(b => b.id !== bar.id)
                            )
                            .map(bar => ({ value: bar.id, label: bar.name }))}
                        searchable={true}
                        clearable={false}
                        id="bowtieEditor-barrierAssignModal-field-barrier"
                        onChange={(opt: Option<number>) => handleSelectNewInfo(opt.value)}
                        value={{ label: selectedBarrier?.name, value: selectedBarrier?.id }}
                    />
                ) : (
                    <ReactSelect
                        disabled
                        options={barriers
                            .filter(bar => selectedBarrierType?.value === bar.barrierType?.id)
                            .filter(bar =>
                                type === 'threat'
                                    ? data?.topEvent?.threats[index]?.barriers.every(b => b.id !== bar.id)
                                    : data?.topEvent?.consequences[index]?.barriers.every(b => b.id !== bar.id)
                            )
                            .map(bar => ({ value: bar.id, label: bar.name }))}
                        searchable={true}
                        clearable={false}
                        id="bowtieEditor-barrierAssignModal-field-barrier"
                        value={{ label: selectedBarrier?.name, value: selectedBarrier?.id }}
                    />
                )}
            </FormField>

            {selectedBarrier ? (
                <BarrierInfoContainer>
                    <hr />
                    <div className="barrier-info-row barrier">
                        {i18n('BARRIER')} <div className="barrier-info-id">#{selectedBarrier.id ?? '--'}</div>
                        {bowtieAdmin && <i className="fas fa-edit" onClick={() => goToEditBarrier(selectedBarrier)} />}
                    </div>
                    <div className="barrier-info-row description">{selectedBarrier.name ?? ''}</div>
                    {/* <hr /> */}
                    <div className="barrier-info-row info">
                        <div className="key">{i18n('Responsible')}</div>
                        <div className="value">{selectedBarrier.supervisor?.name ?? ''}</div>
                    </div>
                    <div className="barrier-info-row info">
                        <div className="key">{i18n('Barrier Category')}</div>
                        <div className="value">{selectedBarrier.barrierType?.name ?? ''}</div>
                    </div>
                    <div className="barrier-info-row info">
                        <div className="key">{i18n('Criticality')}</div>
                        <div className="value">{selectedBarrier.criticality?.level ?? ''}</div>
                    </div>
                    <div className="barrier-info-row info">
                        <div className="key">{i18n('Method')}</div>
                        <div className="value">{i18n(capitalize(selectedBarrier?.method?.method)) ?? ''}</div>
                    </div>
                    <hr />
                </BarrierInfoContainer>
            ) : (
                <BarrierInfoContainer>{i18n('Please select barrier category and barrier')}</BarrierInfoContainer>
            )}
            {selectedBarrier && type === 'threat' && (
                <FormField>
                    <Title>
                        <label className="control-label">{i18n('Safety Critical Barrier (Optional)')}</label>
                        <StyledCustomTooltip content={threatText} position="top">
                            <i className="far fa-info-circle" />
                        </StyledCustomTooltip>
                    </Title>
                    {bowtieAdmin ? (
                        <>
                            <InfoBarrierFlex>
                                <SwitchButton
                                    id="bowtieEditor-barrierAssignModal-checkbox-topEventMandatoryBarrier"
                                    label={i18n('Bowtie Mandatory Barrier')}
                                    value={isTopEventMandatory}
                                    onChange={e => handleChange(item, e === true, e)}
                                />
                            </InfoBarrierFlex>
                            <InfoBarrierFlex>
                                <SwitchButton
                                    id="bowtieEditor-barrierAssignModal-checkbox-threatMandatoryBarrier"
                                    label={i18n('Threat Mandatory Barrier')}
                                    value={isThreatConsequenceMandatory}
                                    disabled={isTopEventMandatory}
                                    onChange={e => !isTopEventMandatory && handleChange(item, e, undefined)}
                                />
                            </InfoBarrierFlex>
                        </>
                    ) : (
                        <>
                            <InfoBarrierFlex>
                                <SwitchButton
                                    id="bowtieEditor-barrierAssignModal-checkbox-topEventMandatoryBarrier"
                                    label={i18n('Bowtie Mandatory Barrier')}
                                    value={isTopEventMandatory}
                                    disabled
                                />
                            </InfoBarrierFlex>
                            <InfoBarrierFlex>
                                <SwitchButton
                                    id="bowtieEditor-barrierAssignModal-checkbox-threatMandatoryBarrier"
                                    label={i18n('Threat Mandatory Barrier')}
                                    value={isThreatConsequenceMandatory}
                                    disabled
                                />
                            </InfoBarrierFlex>
                        </>
                    )}
                </FormField>
            )}
            {selectedBarrier && type === 'consequence' && (
                <FormField>
                    <Title>
                        <label className="control-label">{i18n('Safety Critical Barrier (Optional)')}</label>
                        <StyledCustomTooltip content={consequenceText} position="top">
                            <i className="far fa-info-circle" />
                        </StyledCustomTooltip>
                    </Title>
                    {bowtieAdmin ? (
                        <InfoBarrierFlex>
                            <SwitchButton
                                id="bowtieEditor-barrierAssignModal-checkbox-consequenceMandatoryBarrier"
                                label={i18n('Consequence Mandatory Barrier')}
                                value={isThreatConsequenceMandatory}
                                onChange={e => handleChange(item, e, undefined)}
                            />
                        </InfoBarrierFlex>
                    ) : (
                        <InfoBarrierFlex>
                            <SwitchButton
                                id="bowtieEditor-barrierAssignModal-checkbox-consequenceMandatoryBarrier"
                                label={i18n('Consequence Mandatory Barrier')}
                                value={isThreatConsequenceMandatory}
                                disabled
                            />
                        </InfoBarrierFlex>
                    )}
                </FormField>
            )}
        </EntityEditorModal>
    )
}
